<script lang="ts">
import type { SVGAttributes } from 'svelte/elements';

const props: SVGAttributes<SVGElement> = $props();
</script>

<svg
  aria-hidden="true"
  focusable="false"
  viewBox="0 0 16 16"
  fill="none"
  {...props}
>
  <path
    d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V8.66667H3.33333V12.6667H7.33333V14H3.33333ZM8.66667 14V12.6667H12.6667V8.66667H14V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H8.66667ZM4 11.3333L6 8.66667L7.5 10.6667L9.5 8L12 11.3333H4ZM2 7.33333V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H7.33333V3.33333H3.33333V7.33333H2ZM12.6667 7.33333V3.33333H8.66667V2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V7.33333H12.6667ZM10.3333 6.66667C10.0444 6.66667 9.80556 6.57222 9.61667 6.38333C9.42778 6.19444 9.33333 5.95556 9.33333 5.66667C9.33333 5.37778 9.42778 5.13889 9.61667 4.95C9.80556 4.76111 10.0444 4.66667 10.3333 4.66667C10.6222 4.66667 10.8611 4.76111 11.05 4.95C11.2389 5.13889 11.3333 5.37778 11.3333 5.66667C11.3333 5.95556 11.2389 6.19444 11.05 6.38333C10.8611 6.57222 10.6222 6.66667 10.3333 6.66667Z"
    fill-rule="evenodd"
    fill="currentColor"
  />
</svg>
